import styled from 'styled-components';

export const Image = styled.section`
  figure {
    img {
      display: block;
      margin: 0 auto;
      max-width: 100%;
    }
    figcaption {
      text-align: right;
    }
  }
`;
